import {map as _map} from "lodash";
import * as React from "react";

export interface DietThemesPlanPDFProps {
    id: string;
    planItem: any;
}

const DietThemesPlanPDFTemplate: React.StatelessComponent<DietThemesPlanPDFProps> = (props: DietThemesPlanPDFProps) => {
    let id = props.id;
    let planItem = props.planItem;
    let itemToIterate = planItem[id];
    return (
        <div id={id} className="prescription-grid-row external-row">
            <div className="prescription-card-content">
                <div className={"overall-themes-header brandon-bold"}>DIET THEME</div>
                <div id={`${id}-subsection`} className={"overall-themes-header brandon-bold"}>
                    {
                        _map(itemToIterate, (theme: string) => {
                            return <div className={"theme-text"}>{theme}</div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default DietThemesPlanPDFTemplate;